import CardActionLike from "./card-action-like";

export default CardActionLike;